<template>
      <v-row justify="center">
        <v-dialog v-model="popupShow" persistent max-width="400">
          <v-card>
            <v-card-title center class="display-1 text-center">
              <v-flex class="my-2">Error!</v-flex>
            </v-card-title>
            <v-card-text class="black--text">
              <p class="font-weight-medium body-1">Requested URL does not exist!</p>
              <div class="font-weight-medium body-1 mb-2">
                Check if valid parameters were entered.
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
</template>

<script>

export default {
  name: "BadPage",
 data() {
    return {
      popupShow: true
    }
 }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">

</style>
